import {
  COMPONENT,
  FORM_FIELD_NAMES,
} from "../../../../constants/form-field-names";
import {
  amountOptions,
  zeroDecimalCurrency,
} from "../../../../constants/max-amount.c";
import styles from "../../../../Home.module.css";
import validatorTypes from "@data-driven-forms/react-form-renderer/validator-types";
import { commonSchema } from "./commonSchema";

const getMinAmount = (currency: string) =>
  zeroDecimalCurrency.includes(currency)
    ? amountOptions.MIN_AMOUNT_ZERO_D
    : amountOptions.MIN_AMOUNT_OTHER;

const getMaxAmount = (currency: string) =>
  zeroDecimalCurrency.includes(currency)
    ? amountOptions.MAX_AMOUNT_ZERO_D
    : amountOptions.MAX_AMOUNT_OTHER;

const getCurrencyIconImg = (currency: string) => {
  return "/cards/" + currency.toLowerCase() + "-amount.png"
};

/*export const PaymentSchemaOld: any = (hasGooglepayOrApplePay: any, modelType: any, isJapaneseLanguage=false) => {
  const sgdAmountSchema = {
    component: COMPONENT.DAS_TEXT_FIELD,
    name: FORM_FIELD_NAMES.AMOUNT,
    inputLabel: "merchant.Payment_Information.fields.Amount",

    placeholder: "merchant.Payment_Information.fields.Amount",
    isRequired: true,
    className: hasGooglepayOrApplePay
      ? [styles.formcontrol, "add-margin-amount", "sgdamount"].join(" ")
      : [styles.formcontrol, "remove-margin-amount", "sgdamount"].join(" "),
    validate: [
      {
        type: validatorTypes.MIN_NUMBER_VALUE,
        includeThreshold: true,
        value: getMinAmount("SGD"),
      },
      {
        type: validatorTypes.REQUIRED,
      },
      {
        type: validatorTypes.MAX_NUMBER_VALUE,
        includeThreshold: true,
        value: getMaxAmount("SGD"),
      },
    ],
    type: "number",
    dataType: "float",
  };
  const jpyAmountSchema = {
    component: COMPONENT.DAS_TEXT_FIELD,
    name: FORM_FIELD_NAMES.AMOUNT,
    inputLabel: "merchant.Payment_Information.fields.Amount",

    placeholder: "merchant.Payment_Information.fields.Amount",
    isRequired: true,
    className: hasGooglepayOrApplePay
      ? [styles.formcontrol, "add-margin-amount", "jpyamount"].join(" ")
      : [styles.formcontrol, "remove-margin-amount", "jpyamount"].join(" "),
    validate: [
      {
        type: validatorTypes.MIN_NUMBER_VALUE,
        includeThreshold: true,
        value: getMinAmount("JPY"),
      },
      {
        type: validatorTypes.REQUIRED,
      },
      {
        type: validatorTypes.MAX_NUMBER_VALUE,
        includeThreshold: true,
        value: getMaxAmount("JPY"),
      },
    ],
    type: "number",
    dataType: "integer",
  };
  const usdAmountSchema = {
    component: COMPONENT.DAS_TEXT_FIELD,
    name: FORM_FIELD_NAMES.AMOUNT,
    inputLabel: "merchant.Payment_Information.fields.Amount",

    placeholder: "merchant.Payment_Information.fields.Amount",
    isRequired: true,
    className: hasGooglepayOrApplePay
      ? [styles.formcontrol, "add-margin-amount", "usdamount"].join(" ")
      : [styles.formcontrol, "remove-margin-amount", "usdamount"].join(" "),
    validate: [
      {
        type: validatorTypes.MIN_NUMBER_VALUE,
        includeThreshold: true,
        value: getMinAmount("USD"),
      },
      {
        type: validatorTypes.REQUIRED,
      },
      {
        type: validatorTypes.MAX_NUMBER_VALUE,
        includeThreshold: true,
        value: getMaxAmount("USD"),
      },
      {
        type: validatorTypes.PATTERN,
        pattern: /^(\d{1,7}|\d{0,7}\.\d{1,2})$/,
        message: "merchant.Payment_Information.AmountError",
      },
    ],
    type: "number",
    dataType: "float",
  };

  const hkddAmountSchema = {
    component: COMPONENT.DAS_TEXT_FIELD,
    name: FORM_FIELD_NAMES.AMOUNT,
    inputLabel: "merchant.Payment_Information.fields.Amount",

    placeholder: "merchant.Payment_Information.fields.Amount",
    isRequired: true,
    className: hasGooglepayOrApplePay
      ? [styles.formcontrol, "add-margin-amount", "hkdamount"].join(" ")
      : [styles.formcontrol, "remove-margin-amount", "hkdamount"].join(" "),
    validate: [
      {
        type: validatorTypes.MIN_NUMBER_VALUE,
        includeThreshold: true,
        value: getMinAmount("HKD"),
      },
      {
        type: validatorTypes.REQUIRED,
      },
      {
        type: validatorTypes.MAX_NUMBER_VALUE,
        includeThreshold: true,
        value: getMaxAmount("HKD"),
      },
      {
        type: validatorTypes.PATTERN,
        pattern: /^(\d{1,7}|\d{0,7}\.\d{1,2})$/,
        message: "merchant.Payment_Information.AmountError",
      },
    ],
    type: "number",
    dataType: "float",
  };
  const phpAmountSchema = {
    component: COMPONENT.DAS_TEXT_FIELD,
    name: FORM_FIELD_NAMES.AMOUNT,
    inputLabel: "merchant.Payment_Information.fields.Amount",

    placeholder: "merchant.Payment_Information.fields.Amount",
    isRequired: true,
    className: hasGooglepayOrApplePay
      ? [styles.formcontrol, "add-margin-amount", "phpamount"].join(" ")
      : [styles.formcontrol, "remove-margin-amount", "phpamount"].join(" "),
    validate: [
      {
        type: validatorTypes.MIN_NUMBER_VALUE,
        includeThreshold: true,
        value: getMinAmount("PHP"),
      },
      {
        type: validatorTypes.REQUIRED,
      },
      {
        type: validatorTypes.MAX_NUMBER_VALUE,
        includeThreshold: true,
        value: getMaxAmount("PHP"),
      },
      {
        type: validatorTypes.PATTERN,
        pattern: /^(\d{1,7}|\d{0,7}\.\d{1,2})$/,
        message: "merchant.Payment_Information.AmountError",
      },
    ],
    type: "number",
    dataType: "float",
  };
  const data = {
    JPY: {
      fields: [jpyAmountSchema, ...commonSchema(modelType,isJapaneseLanguage)],
    },
    SGD: {
      fields: [sgdAmountSchema,...commonSchema(modelType,isJapaneseLanguage)],
    },
    USD: {
      fields: [usdAmountSchema,...commonSchema(modelType,isJapaneseLanguage)],
    },
    HKD: {
      fields: [hkddAmountSchema,...commonSchema(modelType,isJapaneseLanguage)],
    },
    PHP: {
      fields: [phpAmountSchema,...commonSchema(modelType,isJapaneseLanguage)],
    },
  };
  return data;
};*/

export const PaymentSchema: any = (hasGooglepayOrApplePay: any, modelType: any, isJapaneseLanguage=false, currency: any) => {

  let currencyDataType = "float";
  if (currency === "JPY") {
    currencyDataType = "integer";
  }

  const AmountSchema = {
    component: COMPONENT.DAS_TEXT_FIELD,
    name: FORM_FIELD_NAMES.AMOUNT,
    inputLabel: "merchant.Payment_Information.fields.Amount",

    placeholder: "merchant.Payment_Information.fields.Amount",
    isRequired: true,
    className: hasGooglepayOrApplePay
      ? [styles.formcontrol, "add-margin-amount", "currency-amount"].join(" ")
      : [styles.formcontrol, "remove-margin-amount", "currency-amount"].join(" "),
    style: {
      backgroundImage: `url(${process.env.PUBLIC_URL + getCurrencyIconImg(currency)})`,
    },
    validate: [
      {
        type: validatorTypes.MIN_NUMBER_VALUE,
        includeThreshold: true,
        value: getMinAmount(currency),
      },
      {
        type: validatorTypes.REQUIRED,
      },
      {
        type: validatorTypes.MAX_NUMBER_VALUE,
        includeThreshold: true,
        value: getMaxAmount(currency),
      },
    ],
    type: "number",
    dataType: currencyDataType,
  };

  const data = {
    fields: [AmountSchema, ...commonSchema(modelType,isJapaneseLanguage)],
  };

  return data;
};
